import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "indicator"]

  connect() {
    this.observeSections()
    window.addEventListener("scroll", this.handleScroll.bind(this))
    this.scrollToHashOnLoad()
  }

  scrollToHashOnLoad() {
    const hash = window.location.hash
    if (hash) {
      const targetId = hash.substring(1)
      const targetSection = document.getElementById(targetId)
      if (targetSection) {
        setTimeout(() => {
          targetSection.scrollIntoView({ behavior: "smooth", block: "start" })
        }, 100)
      }
    }
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll.bind(this))
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  scrollTo(event) {
    event.preventDefault()
    const targetId = event.currentTarget.dataset.target
    const targetSection = document.getElementById(targetId)

    if (targetSection) {
      targetSection.scrollIntoView({ behavior: "smooth", block: "start" })
      history.pushState(null, null, `#${targetId}`)
    }
  }

  observeSections() {
    const options = {
      root: null,
      rootMargin: "-20% 0px -70% 0px",
      threshold: 0
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.setActiveLink(entry.target.id)
        }
      })
    }, options)

    this.linkTargets.forEach((link) => {
      const targetId = link.dataset.target
      const section = document.getElementById(targetId)
      if (section) {
        this.observer.observe(section)
      }
    })
  }

  setActiveLink(sectionId) {
    this.linkTargets.forEach((link) => {
      const isActive = link.dataset.target === sectionId
      link.classList.toggle("active", isActive)

      if (isActive && this.hasIndicatorTarget) {
        this.updateIndicatorPosition(link)
      }
    })
  }

  updateIndicatorPosition(activeLink) {
    const linkRect = activeLink.getBoundingClientRect()
    const navRect = this.element.getBoundingClientRect()
    const offsetTop = linkRect.top - navRect.top + (linkRect.height / 2)

    this.indicatorTarget.style.top = `${offsetTop}px`
  }

  handleScroll() {
    const scrollTop = window.scrollY
    const docHeight = document.documentElement.scrollHeight - window.innerHeight
    const scrollPercent = (scrollTop / docHeight) * 100

    if (this.hasIndicatorTarget) {
      const navHeight = this.element.offsetHeight
      const indicatorTop = (scrollPercent / 100) * navHeight
      this.indicatorTarget.style.top = `${indicatorTop}px`
    }
  }
}
